import type { Translation } from '../types.ts';
import type en from '../en/account.ts';

export default {
    profile: {
        title: 'Profiel',
        account: 'Account',
        roles: 'Rollen',
        activeWebsite: 'Actieve website',
    },
    language: {
        title: 'Taal',
        label: 'Taal van de beheeromgeving',
        hint: 'De taal waarin jij de beheeromgeving ziet. Geldt op elk apparaat waarop je inlogt.',
        browser: 'Zelfde als deze browser ({language})',
        saved: 'Taal opgeslagen',
    },
    passkeys: {
        title: 'Toegangssleutels',
        intro: 'Met een toegangssleutel log je in zonder wachtwoord: je apparaat (of een hardwaresleutel) bewijst dat jij het bent. Je kunt meerdere sleutels registreren (biometrie op je laptop, je telefoon en een hardwaresleutel als reserve) en elk daarvan gebruiken.',
        unsupported: 'Deze browser ondersteunt geen toegangssleutels.',
        label: 'Naam',
        labelPlaceholder: 'bijv. iPhone, werklaptop',
        register: 'Toegangssleutel registreren',
        registerFailed: 'Registreren van de toegangssleutel is mislukt.',
        empty: 'Nog geen toegangssleutels. Registreer er hierboven een om zonder wachtwoord in te loggen.',
        usage: 'Toegevoegd {added} · Laatst gebruikt {used}',
        remove: 'Toegangssleutel verwijderen',
        confirmRemove: 'Toegangssleutel "{label}" verwijderen? Je kunt er daarna niet meer mee inloggen.',
        defaultLabel: 'Toegangssleutel {device}',
        defaultLabelGeneric: 'Toegangssleutel',
    },
} satisfies Translation<typeof en>;
